import React, { useMemo } from 'react'
import { Widget } from 'features/types'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { GeoRegionsWidget } from '../../types'
import { useDashboardWidgetData } from '../../../../../hooks/useWidgetState'
import { useDashboardWidgetSetting } from '../../../../../hooks/useDashboardState'
import { InsightViewOption } from '../../../../../enums'

import { retrieveInsightSet, createGeoData, getUnit, getColorSetting } from './utils'
import GeoChart from '../../../../visualization/Geo'

const GeoRegions: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<GeoRegionsWidget>(widgetId)
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)

  const insightSet = retrieveInsightSet(widgetData)
  const { region, resolution, countType, viewOption } = widgetSetting || {}
  const isPerCapita = viewOption === InsightViewOption.PER_CAPITA
  const geoData = useMemo(() => createGeoData(insightSet!, resolution!, isPerCapita), [
    insightSet,
    resolution,
    isPerCapita
  ])

  return (
    <GeoChart
      data={geoData}
      region={region!}
      resolution={resolution!}
      unit={getUnit(isPerCapita, countType!)}
      colorSetting={getColorSetting(countType!)}
    />
  )
}

export default GeoRegions
